import { render, staticRenderFns } from "./RequestForMaterialsShow.vue?vue&type=template&id=00737eff&"
import script from "./RequestForMaterialsShow.vue?vue&type=script&lang=js&"
export * from "./RequestForMaterialsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports